export default __webpack_public_path__ + "static/media/Vertical container.3833dd93.svg";